import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSelector } from 'reselect';

const initialState = {
    productsByCatalogId: {},
    sortedProductsByCatalog: {},
    catalogProductsStatus: {},
    sortingStatus: {}, 
    error: null,
};

export const fetchProductsByCatalogId = createAsyncThunk(
    'products/fetchByCatalogId',
    async (catalogId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`https://moga-dev.com/api/products/catalog/${catalogId}`);
            return { catalogId, products: response.data.data };
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed to fetch products");
        }
    }
);

export const fetchSortedProducts = createAsyncThunk(
  'products/fetchSortedProducts',
  async ({ catalogId, sortId }, { rejectWithValue }) => {
    try {
      const url = `https://moga-dev.com/api/products/${sortId}`;

      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
        },
      });

      return { catalogId, sortId, sortedProducts: response.data.data };
    } catch (error) {
      console.error("Error fetching sorted products:", error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to fetch sorted products");
    }
  }
);


const productsByCatalogIdSlice = createSlice({
    name: 'getProductsByCatalogId',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductsByCatalogId.pending, (state, action) => {
                const catalogId = action.meta.arg;
                state.catalogProductsStatus[catalogId] = 'pending';
                state.error = null;
            })
            .addCase(fetchProductsByCatalogId.fulfilled, (state, action) => {
                const { catalogId, products } = action.payload;
                state.productsByCatalogId[catalogId] = products;
                state.catalogProductsStatus[catalogId] = 'fulfilled';
            })
            .addCase(fetchProductsByCatalogId.rejected, (state, action) => {
                const catalogId = action.meta.arg;
                state.catalogProductsStatus[catalogId] = 'rejected';
                state.error = action.payload;
            })
            
            .addCase(fetchSortedProducts.pending, (state, action) => {
                const { catalogId } = action.meta.arg;
                state.sortingStatus[catalogId] = 'pending';
            })
            .addCase(fetchSortedProducts.fulfilled, (state, action) => {
                const { catalogId, sortId, sortedProducts } = action.payload;
                if (!state.sortedProductsByCatalog[catalogId]) {
                    state.sortedProductsByCatalog[catalogId] = {};
                }
                state.sortedProductsByCatalog[catalogId][sortId] = sortedProducts;
                state.sortingStatus[catalogId] = 'fulfilled';
            })
            .addCase(fetchSortedProducts.rejected, (state, action) => {
                const { catalogId } = action.meta.arg;
                state.sortingStatus[catalogId] = 'rejected';
            });
    },
});

export const selectCatalogProductsStatus = (state, catalogId) => 
    state.productsByCatalogId.catalogProductsStatus[catalogId];

export const selectProductsByCatalogId = createSelector(
    (state) => state.productsByCatalogId.productsByCatalogId,
    (_, catalogId) => catalogId,
    (productsByCatalogId, catalogId) => productsByCatalogId[catalogId] || []
);

export const selectSortedProductsByCatalog = (state, catalogId, sortId) => 
    state.productsByCatalogId.sortedProductsByCatalog?.[catalogId]?.[sortId] || null;

export const selectError = (state) => state.productsByCatalogId.error;
export const selectLoading = (state) => state.productsByCatalogId.loading;

export default productsByCatalogIdSlice.reducer;
